// Client-side reader for the IndexedDB entry written by the service worker
// when it intercepts a share-target POST from the OS share sheet.

const DB_NAME = 'cardsmith-share';
const STORE_NAME = 'pending';
const ENTRY_KEY = 'latest';

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE_NAME);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

/** Read and atomically clear the pending share text written by the service worker. */
export async function readAndClearShareQueue(): Promise<string | null> {
  try {
    const db = await openDb();
    return await new Promise<string | null>((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const getReq = store.get(ENTRY_KEY);
      getReq.onsuccess = () => {
        const val = getReq.result as string | undefined;
        store.delete(ENTRY_KEY);
        resolve(val ?? null);
      };
      getReq.onerror = () => reject(getReq.error);
    });
  } catch {
    return null;
  }
}
